import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { SyncInProgressBanner } from '@/modules/pmt/components/SyncInProgressBanner';
import { TrackingWidget } from '@/modules/pmt/components/TrackingWidget';
import { useMyParcelsContext } from '@/modules/pmt/context';
import type { FC, JSX } from 'react';
import { SyncInProgressBannerWrapper } from '../../../SyncInProgressBanner/SyncInProgressBanner.styles';
import { MainText, NotLoggedInContent, SubText } from '../../DefaultTrackingContainer.styles';

interface IDefaultBannerProps {
  squareAd?: JSX.Element;
  searchShipments: (trackingIds: string[]) => void;
  showEmailConnectedBanner?: boolean;
}

export const DefaultBanner: FC<IDefaultBannerProps> = ({ squareAd, searchShipments, showEmailConnectedBanner }) => {
  const { trackingTranslation } = useMyParcelsContext();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);

  const mainText = isDesktopPMT ? trackingTranslation.mainTextDesktop : trackingTranslation.mainTextMobile;

  const subText = isDesktopPMT ? trackingTranslation.subTextDesktop : trackingTranslation.subTextMobile;

  return (
    <>
      {/* TW input + Add parcels button */}
      <TrackingWidget handleSubmit={searchShipments} />
      {showEmailConnectedBanner && (
        <SyncInProgressBannerWrapper>
          <SyncInProgressBanner />
        </SyncInProgressBannerWrapper>
      )}
      {squareAd}
      <NotLoggedInContent>
        <img
          src='/images/tracking-default-image.svg'
          alt='tracking-default-image'
          width={isDesktopPMT ? 290 : 236}
          height={isDesktopPMT ? 160 : 130}
          style={{
            objectFit: 'contain',
          }}
        />
        <MainText>{mainText}</MainText>
        <SubText>{subText}</SubText>
      </NotLoggedInContent>
    </>
  );
};
